export const BASE_URL = process.env.APP_BASE_URL || 'https://brainchild.singapore.karmadev.tech';
export const SERVER_URL = process.env.APP_BACKEND_URL || 'https://backend.brainchild.singapore.karmadev.tech';

// export const SERVER_URL = "http://localhost:4000";
